/* eslint-disable no-new */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Markdown from 'react-markdown';
import {
  Build,
  ContactSupportOutlined,
  EmojiObjects,
  Info,
  OpenInBrowser,
  OpenInNew,
  RssFeed,
  ArrowBackIos,
  ArrowForwardIos,
} from '@material-ui/icons';
import App from '../App';
import './Auth.scss';
import logo from './logo_lg.png';
import Globe from '../headlines/Utilities/Globe';
import promo from './promo.png';
import LoadingHud from '../headlines/Utilities/LoadingHud';
import RichTextRenderer from './faceplate/RichTextRenderer';
import { ICON_MAP } from './faceplate/ICON_MAP';

interface AuthResponse {
  jwtToken: string;
  userId: string;
  orgId: string;
  email: string;
  accessToken: string;
  flags: { [key: string]: boolean };
  isAdmin: boolean | undefined;
  superAdmin: boolean;
}

export interface Panel {
  id: string; // UUID
  title: string;
  icon: string;
  status: 'Active' | 'Draft';
  text?: string;
  rank?: number;
  emergency?: boolean;
  regions?: string[];
}

declare global {
  interface Window {
    googleTranslateElementInit: () => void;
    googleTranslateElementLoaded: boolean;
  }
}

window.googleTranslateElementInit = function () {
  try {
    const translateElement = document.getElementById('google_translate_element');
    if (!translateElement) {
      console.error('Google Translate Element not found');
      return;
    }

    if (translateElement.children.length > 0) {
      console.log('Google Translate Initialized');
      return;
    }

    if ((window as any).google?.translate) {
      new (window as any).google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');

      window.googleTranslateElementLoaded = true;
      console.log('Google Translate Element Initialized');
    } else {
      console.log('Google Translate API not available');
    }
  } catch (error) {
    console.log('Google Translate Element Initialization Error: ', error);
  }
};

const mockFetchPanels = async (): Promise<Panel[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: '1',
          title: 'Important Announcement',
          icon: 'announcement',
          status: 'Active',
          text: '<p><strong>We are updating our system</strong> this weekend. Expect brief downtime on <em>Sunday</em>.</p>',
          rank: 1,
          emergency: false,
        },
        {
          id: '2',
          title: 'Latest Changelog',
          icon: 'update',
          status: 'Active',
          text: '<ul><li>Added a new dark mode</li><li>Improved performance</li><li>Bug fixes</li></ul>',
          rank: 2,
          emergency: false,
        },
        {
          id: '3',
          title: 'Contact Support',
          icon: 'chat',
          status: 'Active',
          text: "<p>Need help? Contact our support team at <a href='mailto:support@example.com'>support@example.com</a> or call <strong>1-800-555-1234</strong>.</p>",
          rank: 3,
          emergency: false,
        },
      ]);
    }, 500);
  });
};

const AuthFooter = () => {
  return (
    <div className="auth-footer">
      <a
        className="footer-link"
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        href="https://telecost.com/termsofuse.php"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use <OpenInNew style={{ fontSize: '1em' }} />
      </a>
      <b className="footer-link">|</b>

      <a
        className="footer-link"
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        href="https://telecost.com/privacy.php"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy <OpenInNew style={{ fontSize: '1em' }} />
      </a>
      <b className="footer-link">|</b>
      <a
        className="footer-link"
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        href="https://telecost.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        About Us <OpenInNew style={{ fontSize: '1em' }} />
      </a>
    </div>
  );
};

const AuthError = ({ type }: { type: number | boolean }) => {
  return (
    <>
      <div className="auth-error-container">
        <div className="auth-error-content">
          {type === 503 && (
            <>
              <h1>Hang Tight! 🚧</h1>
              <p>
                Our team is still configuring your environment. You&apos;ll have access shortly--please check back soon!
              </p>
            </>
          )}
          {type === 401 && (
            <>
              <h1>Installation Request Received ✅</h1>
              <p>
                Your login request was accepted. If you have already been installed, please try a different region.
                Otherwise, please contact{' '}
                <a href="mailto:support@telecost.com" target="_blank">
                  support@telecost.com
                </a>{' '}
                for assistance.
              </p>
            </>
          )}
          {type === 403 && (
            <>
              <h1>Installation Blocked 🚫</h1>
              <p>
                Your login request was denied. Your account has been disabled. Please contact{' '}
                <a href="mailto:support@telecost.com" target="_blank">
                  support@telecost.com
                </a>{' '}
                for assistance.
              </p>
            </>
          )}
          {type !== 503 && type !== 401 && type !== 403 && type !== 400 && type && (
            <>
              <h1>{type}</h1>
              <p>
                The page you are looking for is unavailable. Please check back later, or contact{' '}
                <a href="mailto:support@telecost.com" target="_blank">
                  support@telecost.com
                </a>{' '}
                for assistance.
              </p>
            </>
          )}
          <button
            onClick={async () => {
              await deleteCookie();
              window.location.reload();
            }}
            type="button"
            className="auth-error-back"
          >
            Back to Sign in
          </button>
        </div>
      </div>
      <img
        style={{
          height: 35,
          width: 35,
          borderRadius: 50,
          position: 'absolute',
          bottom: 20,
          right: '50%',
          transform: 'translateX(50%)',
        }}
        alt="logo"
        src={logo}
      />
    </>
  );
};

export const deleteCookie = async () => {
  await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
    method: 'post',
    credentials: 'include',
  });
};

function Auth() {
  const [code] = useState(new URLSearchParams(window.location.search).get('code'));
  const [mode, setMode] = useState<string>('light');
  const [authRes, setAuthRes] = useState<AuthResponse | undefined>(undefined);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [startRegion] = useState<string | null>(() => {
    const url = window.location.href;
    if (url.includes('uk')) {
      return 'eu-west-2';
    }
    if (url.includes('dev')) {
      return 'dev';
    }
    if (url.includes('localhost')) {
      return 'dev';
    }
    if (url.includes('na2')) {
      return 'us-west-1';
    }
    return 'us-east-1';
  });

  const [region, setRegion] = useState<string | null>();
  const clientId = process.env.REACT_APP_RINGCENTRAL_CLIENT_ID as string;
  const redirectUri = process.env.REACT_APP_RINGCENTRAL_REDIRECT_URI as string;
  const state = Math.random().toString(36).substring(2);
  const authUrl = `https://platform.ringcentral.com/restapi/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&state=${state}`;
  const [reqStatus, setReqStatusCode] = useState<number | boolean>(false);

  useEffect(() => {
    const isOverride = new URLSearchParams(window.location.search).get('jwt');
    if (code && !isOverride) {
      const url = new URL(window.location.href);
      url.searchParams.delete('code');
      url.searchParams.delete('state');
      window.history.replaceState({}, '', url.toString());
      // Login
      (async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/jwt`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code, redirectUri }),
        });
        if (res.ok) {
          const info = await res.json();
          if (info.url) {
            window.location.href = info.url;
          } else {
            setAuthRes(info);
            setVerified(true);
          }
        } else {
          setLoading(false);
          setAuthRes(undefined);
          setVerified(false);
        }
        if (res.status !== 400) {
          setReqStatusCode(res.status);
        }
      })();
    } else if (!isOverride) {
      (async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/jwt`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (res.ok) {
          const info = await res.json();
          if (info.url) {
            // redirect
            window.location.href = info.url;
          } else {
            setAuthRes(info);
            setVerified(true);
          }
        }
        setLoading(false);
      })();
    } else {
      setLoading(false);
    }
  }, [code]);

  useEffect(() => {
    if (authRes && verified) {
      setLoading(false);
    }
  }, [authRes, verified]);

  useEffect(() => {
    const scriptId = 'google-translate-script';
    let currentAttempt = 0;
    const maxAttempt = 3;

    const loadScript = () => {
      if (document.getElementById(scriptId)) return;

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;

      script.onload = () => {
        console.log('Google Translate Script Loaded');
        // Wait for script to initialize
        setTimeout(window.googleTranslateElementInit, 1000);
      };

      script.onerror = () => {
        currentAttempt += 1;
        console.error(`Google Translate Script Failed to Load (Attempt: ${currentAttempt})`);
        if (!document.getElementById(scriptId) && currentAttempt < maxAttempt) {
          setTimeout(loadScript, 1000 * currentAttempt);
        }
      };

      document.body.appendChild(script);
    };

    // Initial load
    loadScript();

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  useEffect(() => {
    let timeoutId: any;
    let backgroundTime: number | null = null;
    const currentDate: string = new Date().toLocaleDateString(); // Store the current date in the user's timezone

    const refreshAuth = async () => {
      if (authRes && verified) {
        console.log('Attempting Refresh');
        const res = await fetch(`${process.env.REACT_APP_API_URL}/jwt`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (res.ok) {
          setAuthRes(await res.json()); // Could be a problem point
          setReqStatusCode(res.status);
          timeoutId = setTimeout(refreshAuth, 30 * 60 * 1000);
        }
        // Commented out to prevent dropped calls.
        // else {
        //   window.location.reload(); // Force page refresh
        // }
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // App goes into the background
        backgroundTime = Date.now(); // Record the time when the app goes into the background
      } else {
        // App comes back to the foreground
        const now = Date.now();
        const newDate = new Date().toLocaleDateString(); // Get the current date in the user's timezone

        // Check if midnight has passed
        if (newDate !== currentDate) {
          window.location.reload(); // Hard refresh if midnight has passed
          return;
        }

        // Check if the app was in the background for more than 20 minutes
        // if (backgroundTime && now - backgroundTime > 20 * 60 * 1000) {
        //   refreshAuth();
        // }

        backgroundTime = null; // Reset the background time
      }
    };

    const startTimer = () => {
      timeoutId = setTimeout(refreshAuth, 30 * 60 * 1000); // Refresh auth every 30 minutes
    };

    startTimer();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [authRes, verified]);

  useEffect(() => {
    if (document.body) {
      if (mode === 'dark') {
        document.body.style.background = '#333';
      }
      if (mode === 'light') {
        document.body.style.background = 'white';
      }
    }
  }, [mode]);

  interface PanelRes {
    SortKey: string;
    PartitionKey: string;
    Panel: Panel;
  }

  const [panels, setPanels] = useState<Panel[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/login-msgs`, {
          method: 'GET',
        });

        if (!res.ok) throw new Error(`Failed to fetch panels: ${res.status}`);

        const data: PanelRes[] = await res.json();
        const panelset: Panel[] = data.map((pan) => pan.Panel);

        // let data = await mockFetchPanels();
        // Filter only "Active" panels
        // data = data.filter((panel) => panel.status === "Active");

        // Sort: Emergency panels first, then by rank
        panelset.sort((a, b) => {
          if (a.emergency && !b.emergency) return -1;
          if (!a.emergency && b.emergency) return 1;
          return (a.rank || 0) - (b.rank || 0);
        });

        setPanels(panelset);
      } catch (error) {
        console.error(`${error}`);
      }
    })();
  }, []);

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % panels.length);
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + panels.length) % panels.length);
  };

  useEffect(() => {
    if (region && region !== startRegion) {
      const regionMap: Record<string, string> = {
        'us-east-1': 'https://shadowagent.rsicloud.com',
        'eu-west-2': 'https://shadowagent.uk.rsicloud.com',
        dev: 'https://na3.dev.rsicloud.com',
        'us-west-1': 'https://shadowagent.na2.rsicloud.com',
      };
      const redirectionUrl = regionMap[region];
      if (redirectionUrl) {
        window.location.replace(redirectionUrl);
      }
    }
  }, [region]);

  const handleRegionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRegion(e.target.value);
  };

  useEffect(() => {
    if (authRes !== undefined) {
      if ((window as any)?.chrome && (window as any)?.chrome?.webview) {
        (window as any).chrome.webview?.postMessage({
          rec: {
            event: 'LOGGED_IN',
            version: '1.0.18',
          },
        });
      }
    }
  }, [authRes]);

  // Impersonate
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const jwt = params.get('jwt');
    const orgId = params.get('orgId');
    const rcId = params.get('userId');
    const email = params.get('email');
    const rcAccessToken = params.get('token') || "Override Mode";
    const isAdmin = true;
    const isSuperAdmin = true;
    const flags = JSON.parse(localStorage.getItem('authInfo') || '{}');
    console.log(flags);
    if (jwt && orgId && rcId && email) {
      setReqStatusCode(200);
      setAuthRes({
        jwtToken: jwt,
        orgId,
        userId: rcId,
        email,
        accessToken: rcAccessToken,
        flags: flags?.flags || {},
        isAdmin,
        superAdmin: isSuperAdmin,
      });
      setVerified(true);
    }
  }, []);

  if (loading) {
    return <LoadingHud mode={mode} />;
  }

  if (reqStatus && reqStatus !== 200 && reqStatus !== 400) {
    return (
      <div className="auth-page-container">
        <div className="auth-page-right error-override" style={{ margin: 0 }}>
          <div className="auth-page-bg">
            <Globe />
          </div>
        </div>
        <AuthError type={reqStatus} />
      </div>
    );
  }

  if (reqStatus === 200 || !reqStatus)
    return (
      <>
        {authRes && verified && (
          <App
            mode={mode}
            setMode={setMode}
            idToken={authRes.jwtToken}
            organizationId={authRes.orgId}
            rcId={`${authRes.userId}`}
            email={authRes.email}
            clientId={clientId}
            redirectUri={encodeURIComponent(redirectUri)}
            rcAccessToken={authRes.accessToken}
            flags={authRes.flags}
            isAdmin={!!authRes.isAdmin}
            superAdmin={!!authRes?.superAdmin}
          />
        )}
        <div style={{ display: !authRes ? 'block' : 'none' }}>
          <div className="auth-page-container">
            <div className="auth-page-left">
              <div className="auth-page-changelog-container">
                <div className="hero-body">
                  {panels.length > 0 && (
                    <div className="content">
                      <div className="landing-content_icon">
                        {ICON_MAP[panels[currentSlide].icon]}
                        <h1>{panels[currentSlide].title}</h1>
                      </div>
                      <div className="richtext-content notranslate">
                        <RichTextRenderer content={panels[currentSlide].text || ''} />
                      </div>
                    </div>
                  )}
                </div>

                {panels.length > 1 && (
                  <>
                    <button className="nav-arrow left" onClick={handlePrev} type="button">
                      <ArrowBackIos fontSize="large" />
                    </button>
                    <button className="nav-arrow right" onClick={handleNext} type="button">
                      <ArrowForwardIos fontSize="large" />
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="auth-page-right">
              <div className="auth-page-bg">
                <Globe />
              </div>
              <h1 className="brand-label_mobile notranslate">Shadow Agent</h1>
              <div className="auth-page-control-container">
                <h1 className="notranslate brand-label_desktop">Shadow Agent</h1>
                <img src={logo} alt="logo" className="splash-logo" />
                {/* <div className="auth-row">
                  <p>Select Server</p>
                  <select
                    name="region-select"
                    id="auth-region-select"
                    onChange={handleRegionChange}
                    defaultValue={startRegion || 'us-east-1'}
                  >
                    <option value="us-east-1">North America</option>
                    <option value="us-west-1">North America 2</option>
                    <option value="eu-west-2">Europe</option>
                  </select>
                </div> */}
                <div className="auth-row">
                  <div id="google_translate_element" />
                </div>
                <div className="auth-row">
                  <a className="auth-button_login" type="button" href={authUrl}>
                    Sign In
                  </a>
                </div>
              </div>
              <div className="auth-footer">
                <a
                  className="footer-link"
                  style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  href="https://telecost.com/termsofuse.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use <OpenInNew style={{ fontSize: '1em' }} />
                </a>
                <b className="footer-link">|</b>

                <a
                  className="footer-link"
                  style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  href="https://telecost.com/privacy.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy <OpenInNew style={{ fontSize: '1em' }} />
                </a>
                <b className="footer-link">|</b>
                <a
                  className="footer-link"
                  style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  href="https://telecost.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About Us <OpenInNew style={{ fontSize: '1em' }} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  return <></>;
}

export default Auth;
